<template>
  <component :is="currentHeaderComponent" />
</template>

<script>
import { CURRENT_PROJECT_PHASE, PROJECT_PHASE } from 'enums/project-phase'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'AHeaderWrapper',
  computed: {
    currentHeaderComponent() {
      const HEADER_COMPONENT_BY_PROJECT_PHASE = {
        [PROJECT_PHASE.NOMINATION]: hydrateWhenVisible(() =>
          import('@/components/_layout/headers/AHeaderNomination/index.vue')
        ),
        [PROJECT_PHASE.VOTING]: hydrateWhenVisible(() =>
          import('@/components/_layout/headers/AHeaderVoting/index.vue')
        ),
        [PROJECT_PHASE.WINNERS]: hydrateWhenVisible(() =>
          import('@/components/_layout/headers/AHeaderWinners/index.vue')
        )
      }

      return HEADER_COMPONENT_BY_PROJECT_PHASE[CURRENT_PROJECT_PHASE]
    }
  }
}
</script>

<style lang="scss" scoped></style>
